 
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class TableHeader extends Vue {
    @Prop(Array) readonly headers!: string[];
   
    get tableHeaderClass() {
      return `px-3 py-3 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-600 uppercase tracking-wider`
    }
  }
